import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { ScrollSync } from 'react-virtualized'

import { getOrderedDates, getOrderedTimes, getDatesToTimesToDeals, getGridRecomputeTime } from 'selectors/grid'

import Grid from './grid'
import GridCanvasSyncFix from './grid-canvas-sync-fix'


const createRowHeightFunction = (dates, datesToTimesToDeals) => ({ index }) => {
  const dateId = dates.toIndexedSeq().get(index).get('id')
  const dateTimes = datesToTimesToDeals.get(dateId)

  const maxDealCount = dateTimes ? dateTimes.maxBy(dateTimeDeals => dateTimeDeals.count()).count() : 0
  const dealHeight = 74
  const bottomPadding = 70
  return Math.max(120, (maxDealCount * dealHeight) + bottomPadding)
}

class GridContainer extends Component {

  render() {
    const {
      cellWidth,
      dates,
      datesToTimesToDeals,
      gridRecomputeTime,
      headerHeight,
      height,
      leftHeaderCellWidth,
      times,
      width,
    } = this.props

    return (
      <div>
        <ScrollSync>
          {({ onScroll, scrollLeft, scrollTop }) => (
            <Grid
              cellWidth={cellWidth}
              dates={dates}
              gridRecomputeTime={gridRecomputeTime}
              headerHeight={headerHeight}
              height={height}
              leftHeaderCellWidth={leftHeaderCellWidth}
              onScroll={onScroll}
              calculateRowHeight={createRowHeightFunction(dates, datesToTimesToDeals)}
              scrollLeft={scrollLeft}
              scrollTop={scrollTop}
              times={times}
              width={width}
            />
          )}
        </ScrollSync>
        <GridCanvasSyncFix />
      </div>
    )
  }
}

GridContainer.propTypes = {
  cellWidth: PropTypes.number.isRequired,
  dates: PropTypes.object.isRequired,
  datesToTimesToDeals: PropTypes.object.isRequired,
  gridRecomputeTime: PropTypes.number.isRequired,
  headerHeight: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  leftHeaderCellWidth: PropTypes.number.isRequired,
  times: PropTypes.object.isRequired,
  width: PropTypes.number.isRequired,
}

const mapStateToProps = state => ({
  dates: getOrderedDates(state),
  datesToTimesToDeals: getDatesToTimesToDeals(state),
  gridRecomputeTime: getGridRecomputeTime(state),
  times: getOrderedTimes(state),
})

export default connect(mapStateToProps)(GridContainer)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-container.js
 **/